import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import UserProvider from "./context/userContext";
import { app } from "./context/firebaseConfig";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";

import "./font/arista/Arista2.0.ttf";
import "./font/arista/Arista2.0Alternate.ttf";

import "./font/biko/Biko_Regular.otf";
import "./font/biko/Biko_Bold.otf";

app.analytics();

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
